export default "__VITE_ASSET__C7z3OH$E__"